import BaseModelAPI from '../BaseModelAPI';

export default class PickingSupplyForSubcontractScanner extends BaseModelAPI {
	static entity = 'pickingsupplyforsubcontractscanner';
	static entityName = 'pickingsupplyforsubcontract';

	constructor(){

	/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.pickingSupplyForSubcontractId = '';
		this.pickingSupplyForSubcontractNumber  = '';
		this.pickingSupplyForSubcontractDetailId  = '';
		this.pickingSupplyForSubcontractDetailPartNumber  = '';
		this.controlCardId  = '';
		this.controlCardNumber  = '';
		this.remarks  = '';
	}

	static async doRequest(this_, method, data) {
        return this_.$http.post(`${this.entityName}/${method}`, data)
        .then(response => {
			return response.data;
        })
        .catch(function(error){
            throw error;
        });
    }

}